// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1WaWL","productName":"Table_productName__17ePB"};